import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocalizationResponse } from "../types/search";


const localizationSlice = createSlice({
  name: "localization",
  initialState: {
    lang: "en",
    currency: "SAR",
    nationality: "SA",
  },
  reducers: {
    setLocalization(state, action: PayloadAction<Partial<LocalizationResponse>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setLocalization } = localizationSlice.actions;
export default localizationSlice.reducer;
